import GrossisteDash from './GrossisteDashboard';

export const GrossisteDashboard = GrossisteDash;
